import React, { useLayoutEffect, useState } from 'react';
import { Modal, Button } from 'components';
import { parseDomain, ParseResultType } from "parse-domain";
import { getCookie } from 'utils/getCookieByName';

import languages from './languages';

import * as Styled from './styles';

export function FlagSwitch() {
  const [flagIndex, setFlagIndex] = useState(0);
  const [isActived, setIsActived] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [languageWanted, setLanguageWanted] = useState<string>('');
  const [disclaimerText, setDisclaimerText] = useState<string>('');
  const [confirmationButtonText, setConfirmationButtonText] = useState<string>('');
  const [closeButtonText, setCloseButtonText] = useState<string>('');
  const [indexLanguageWanted, setIndexLanguageWanted] = useState<any>(null);

  const { index: indexStoraged } = JSON.parse(
    getCookie('language') || '{}',
  );

  const handleChangeLanguage = (language: string, index: number) => {
    //setFlagIndex(index);
    //i18n.changeLanguage(language);

    // open modal de confirmação
    if(language == 'pt-BR'){
      setLanguageWanted(language);
      setIndexLanguageWanted(index);
      handleConfirm(true);
    } else {
      setOpenModal(true);
      setLanguageWanted(language);
      setIndexLanguageWanted(index);
      if(language == 'en-US') {
        setDisclaimerText('This is an automatic translation (Google Translate) from Portuguese (Brazil) to English. Do you want to continue?');
        setConfirmationButtonText('Yes');
        setCloseButtonText('No');
      }
      else if(language == 'es-ES') {
        setDisclaimerText('Esta es una traducción automática (Google Translate) del Portugués (Brasil) al Español. ¿Quieres continuar?');
        setConfirmationButtonText('Sí');
        setCloseButtonText('No');
      }
    }
  };

  const handleConfirm = (clearTranslate: boolean) => {
    
    if(languageWanted == 'pt-BR' || clearTranslate) {
      clearCookies();
    }
    else if(languageWanted == 'en-US'){
      clearCookies();
      document.cookie = 'googtrans=/pt/en; Path=/;';
    }
    else if(languageWanted == 'es-ES'){
      clearCookies();
      document.cookie = 'googtrans=/pt/es; Path=/;';
    }

    document.cookie = 'language=' + JSON.stringify({ language: languageWanted, index: indexLanguageWanted });
    setOpenModal(false);
    setIsActived(false);
    location.reload();
  };

  const clearCookies = () => {
    const parseResult = parseDomain(window.location.hostname);
    if (parseResult.type === ParseResultType.Listed) {
      const { topLevelDomains } = parseResult;
      document.cookie = 'googtrans=/pt/pt; Path=/; domain= ' + parseResult.domain + '.' + topLevelDomains.join('.') + '; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    }
    document.cookie = 'googtrans=/pt/pt; Path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  }

  useLayoutEffect(() => {
    if (indexStoraged) {
      setFlagIndex(indexStoraged);
    }
  }, []);

  return (
    <Styled.Wrapper>
      <button
        type="button"
        className="flagOptionBlock"
        onClick={() => setIsActived(!isActived)}
      >
        <div className='languageLabel'>
          {languages[flagIndex].label}
        </div>
        <div className='languageFlag'>
          {languages[flagIndex].icon}
        </div>
        
      </button>
      {isActived && (
        <Styled.LanguageOptions className='notranslate'>
          {languages.map((item, index) => (
            <div
              key={item.id}
              className="option"
              onClick={() => {
                //onChangeLanguage();
                handleChangeLanguage(item.language, index);
              }}
            >
              {item.icon}
              {item.label}
            </div>
          ))}
        </Styled.LanguageOptions>
      )}
      {openModal && (
        <Modal onDisabled={() => setOpenModal(false)}>
          <Styled.Modal className='notranslate'>
            <p>
              <strong>
                {disclaimerText}
              </strong>
            </p>

            <div className="buttons">
              <Button outline={true} onClick={() => setOpenModal(false)}>
                {closeButtonText}
              </Button>

              <Button onClick={() => {handleConfirm(false)}}> {confirmationButtonText} </Button>
            </div>
          </Styled.Modal>
        </Modal>
      )}
    </Styled.Wrapper>
  );
}
